import React, {type JSX, type ReactNode} from 'react';
import {Box} from '@mui/material';
import Header from './header';

type Props = {
  children: ReactNode;
};

function PageWrapper({children}: Readonly<Props>): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default PageWrapper;
